import { createContext, useReducer } from 'react';
import { Map as map } from 'immutable';

const notificationsReducer = (state, action) => {
  switch (action.type) {
    case 'add':
      return state.set(action.data.created, action.data);
    case 'remove':
      return state.delete(action.id);
    default:
      return state;
  }
};

export const useNotificationsStore = () => useReducer(notificationsReducer, map());

export default createContext(() => map());

